import { Box, Button, CircularProgress, Popover, Tab, Tabs, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { navigateFromClick } from "shared/services/navigationClick";
import { useMyWorkCount } from "../hooks/useMyWorkCount";
import { myWorkApi, myWorkKeys, WorkKind, WorkScope } from "../services/my-work-api";
import { MyWorkItemList } from "./MyWorkItemList";

export function MyWorkPopover({ anchor, onClose }: { anchor: HTMLElement | null; onClose: () => void }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { scope, setScope, count } = useMyWorkCount();
    const [kind, setKind] = useState<WorkKind>("task");
    const items = useQuery({ queryKey: myWorkKeys.items(scope, kind, 10, 0, ""),
        queryFn: () => myWorkApi.listItems({ scope, kind, limit: 10 }), enabled: Boolean(anchor) });
    return <Popover open={Boolean(anchor)} anchorEl={anchor} onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { width: 400, maxWidth: "calc(100vw - 24px)", maxHeight: "70vh", overflow: "auto", p: 1 } }}>
        <Box tabIndex={-1} sx={{ p: 1 }}>
            <Typography variant="h6">{t("my_work.title")}</Typography>
            <ToggleButtonGroup value={scope} exclusive size="small" onChange={(_, value: WorkScope | null) => {
                if (value) void setScope(value);
            }} aria-label={String(t("my_work.scope_label"))} sx={{ mt: 1 }}>
                <ToggleButton value="mine">{t("my_work.scope.mine")}</ToggleButton>
                <ToggleButton value="mine_and_groups">{t("my_work.scope.mine_and_groups")}</ToggleButton>
            </ToggleButtonGroup>
            <Tabs value={kind} onChange={(_, value: WorkKind) => setKind(value)} aria-label={String(t("my_work.title"))}>
                <Tab value="task" label={`${t("my_work.tabs.tasks")} (${count.data?.tasks ?? 0})`} />
                <Tab value="approval" label={`${t("my_work.tabs.approvals")} (${count.data?.approvals ?? 0})`} />
            </Tabs>
            {items.isLoading ? <CircularProgress size={24} /> : <MyWorkItemList items={items.data?.items || []} kind={kind} onNavigate={onClose} />}
            <Button fullWidth onClick={event => { navigateFromClick(event, navigate, `/home/workspace/my-work?tab=${kind}`); onClose(); }}>
                {t("my_work.view_all")}</Button>
        </Box>
    </Popover>;
}
